import React, { useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import { m } from 'framer-motion'

export default function AnimatedCard({ children, className = "", delay = 0 }) {
  const cardRef = useRef(null)

  return (
    <m.div
      ref={cardRef}
      className={`relative ${className}`}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.6, delay, ease: "easeOut" }}
      whileHover={{ 
        y: -10,
        transition: { duration: 0.3 }
      }}
      style={{
        transformStyle: 'preserve-3d',
      }}
    >
      <div className="relative h-full bg-white rounded-2xl shadow-lg overflow-hidden group transition-all duration-300 hover:shadow-2xl">
        <div className="absolute inset-0 bg-gradient-to-br from-fastblue/5 to-neonorange/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="relative z-10 p-8">
          {children}
        </div>
        <div className="absolute inset-0 border-2 border-transparent group-hover:border-fastblue/20 rounded-2xl transition-all duration-300"></div>
      </div>
    </m.div>
  )
}




